export const state = {
  data: {
    title: 'Container One Way',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/conf',
      },
      {
        text: 'Block Container Booking',
        href: '/adm/conf/block-container/booking',
        active: true,
      },
    ],
    modal: false,
    items_tools: [
      {
        id: '1',
        kode: 'CN001210700001',
        code: 'SEJ',
        document_no: 'P3038008',
        container: 'DRYU3321123',
        size: '20',
        type: 'GP',
        remark: 'Document tidak sesuai',
        status: 'block',
        shipper_name: 'PT Sentosa Jaya',
        shipper_group: 'PT Sentosa Group',
      },
      {
        id: '2',
        code: 'WKL',
        document_no: 'JKL33892',
        container: 'BTWU8859443',
        size: '20',
        type: 'GP',
        remark: '',
        status: 'release',
        shipper_name: 'PT Waskita',
        shipper_group: 'PT Waskita Group',
      },
    ],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_pti',
    sortDesc: false,
    fields_tools: [
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: false,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: false,
      },
      {
        key: 'aksi',
        thStyle: {
          width: '15%',
        },
      },
    ],
    form: {
      code: '',
      name: '',
      address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
      free_storage: '',
      add_storage: '',
      min_storage: '',
      max_storage: '',
    },
    container_list: [
      {
        id: '1',
        prefix: 'KTWU',
        number: '3321123',
        size: '20',
        type: 'GP',
        ct: 'WW',
        status: 'new',
        payment: 'not paid',
      },
      {
        id: '1',
        prefix: 'QETU',
        number: '3321123',
        size: '20',
        type: 'GP',
        ct: 'WW',
        status: 'new',
        payment: 'not paid',
      },
      {
        id: '2',
        prefix: 'DRYU',
        number: '2234456',
        size: '40',
        type: 'GP',
        ct: 'WW',
        status: 'available',
        payment: 'paid',
      },
      {
        id: '3',
        prefix: 'SKLU',
        number: '4234456',
        size: '40',
        type: 'GP',
        ct: 'WW',
        status: 'damage',
        payment: 'paid',
      },
      {
        id: '4',
        prefix: 'ERTW',
        number: '8837441',
        size: '20',
        type: 'HC',
        ct: 'WW',
        status: 'available',
        payment: 'paid',
      },
      {
        id: '5',
        prefix: 'TRWU',
        number: '772634',
        size: '20',
        type: 'GP',
        ct: 'WW',
        status: 'available',
        payment: 'paid',
      },
      {
        id: '6',
        prefix: 'WKRT',
        number: '8839921',
        size: '40',
        type: 'GP',
        ct: 'WW',
        status: 'damage',
        payment: 'paid',
      },
    ],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeBlocking(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  getListEstimate({ commit }, message) {
    commit('changeBlocking', message);
  },

  createBooking({ commit, state }) {
    commit('changeBlocking', {
      loading: true,
    });

    console.log(state.data.form);
  },
};
